export interface BoardSortedDirectionProps {
  key: string;
  direction: BoardSortedDirectionType;
}

export type BoardSortedDirectionType = "asc" | "desc" | "";

export const getSortedBoard = (
  cards: any,
  key: string,
  direction: BoardSortedDirectionType
) => {
  return [...cards].sort((a: any, b: any) => {
    let aVal = a[key];
    let bVal = b[key];

    // Si es nested (redemptions)
    if (key === "redemptions") {
      aVal = a.redemptions.used;
      bVal = b.redemptions.used;
    }

    // Si es nested (value)
    if (key === "value") {
      aVal = a.value.value;
      bVal = b.value.value;
    }

    // Si es nested (amount)
    if (key === "amount") {
      aVal = a.amount.amount;
      bVal = b.amount.amount;
    }

    // Si es fecha
    if (key === "expiration" || key === "date") {
      const [da, ma, ya] = aVal.split("/").map(Number);
      const [db, mb, yb] = bVal.split("/").map(Number);
      aVal = new Date(ya, ma - 1, da);
      bVal = new Date(yb, mb - 1, db);
    }

    if (typeof aVal === "string") {
      aVal = aVal.toLowerCase();
      bVal = bVal.toLowerCase();
    }

    if (aVal < bVal) return direction === "asc" ? -1 : 1;
    if (aVal > bVal) return direction === "asc" ? 1 : -1;
    return 0;
  });
};
